module.exports = __webpack_public_path__ + "img/swingVariabilityText5.dd02bbd6.png";